import { MetaState, MetaAction, SET_META } from './types'

export const initState: MetaState = {
	isLoading: false,
}

export const metaReducer = (state = initState, action: MetaAction) => {
	const { type, payload } = action

	switch (type) {
		case SET_META:
			return { ...state, ...payload }
		default:
			return state
	}
}

export default metaReducer
